export default function About() {
  return (
    <section className="relative w-full bg-[#FFFBF4] pb-20 md:pb-10 px-3">
      <div className="max-w-7xl mx-auto">
        {/* Card Box */}
        <div className=" overflow-hidden ">
          <div className="px-8 py-12 md:p-16 text-center">
            {/* Icon */}
            <div className="flex justify-center mb-6">
              <span className="text-5xl md:text-6xl text-[#514b3c] animate-[float_3s_ease-in-out_infinite] select-none drop-shadow-lg">
                ❦
              </span>
            </div>
            {/* Heading */}
            <h2 className="font-serif text-[#282414] text-2xl md:text-[2.2rem] font-semibold tracking-widest mb-6">
              About The Author: Sweta Singh
            </h2>
            {/* Divider */}
            <div className="flex justify-center mb-8">
              <span className="block w-20 h-1 bg-[#e7dfc9] rounded-full" aria-hidden />
            </div>
            {/* Content */}
            <div className="text-[#403a2c] text-[1.16rem] leading-[2.1] font-light space-y-6 text-left md:text-center">
              <p>
                Sweta Singh writes stories for the places people don’t always speak about — the quiet corners of the heart, the hidden rooms of memory, and the fragile space between truth and silence.
              </p>
              <p>
                Her debut novel, <span className="italic">When the Rain Paused</span>, moves into a different emotional landscape — a deeply romantic, intense love story set against longing, loss, and destiny. Where Rain explores what stays — love that survives distance, fear, and time.
              </p>
              <p>
                Her second novel, <span className="italic">When the Shadows Spoke</span>, is a dark, emotionally layered thriller that explores identity, erased histories, and the invisible cost of doing what is right. It reflects her fascination with how power shapes narratives — and how ordinary people carry extraordinary moral weight when no one is watching.
              </p>
              <p>
                Though her worlds are different, Sweta’s writing is guided by one unwavering belief:{" "}
                <span className="block italic text-[#988b6d] mt-1">
                  that the most powerful stories are not only about events — they are about what those events do to the human soul.
                </span>
              </p>
              <p>
                By profession, she is an HR leader, working closely with people, conflict, ambition, emotions and resilience every day. That lived experience flows quietly into her fiction, giving her characters an emotional truth that feels real, flawed, and deeply human.
              </p>
              <p>
                Sweta does not write to escape reality — she writes to understand it. Her stories are for readers who are drawn to emotional depth, layered characters, and narratives that linger long after the final page.
              </p>
              <p>
                She believes that love can be gentle yet fierce, truth can be honest yet dangerous, and silence can carry its own kind of poetry. And through every book, she invites her readers to look beneath the surface — into the places where shadows speak and rain waits to fall.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Decorative background blobs (optional improvement) */}
      <div className="absolute top-0 left-0 w-72 h-72 rounded-full bg-[#ece8db] opacity-30 -z-10 blur-2xl -translate-x-1/2 -translate-y-1/3 pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-96 h-80 rounded-full bg-[#f4ecd3] opacity-20 -z-10 blur-3xl translate-x-1/4 translate-y-1/3 pointer-events-none" />
    </section>
  );
}